export function intersection(arr1: any, arr2: any, comparator: any) {
  return arr1.filter((val1: any) => arr2.some((val2: any) => comparator(val1, val2)))
}
